import AuthMixin from '@/components/mixins/auth-mixin'
import UserAddressComp from '@/components/common/user-address/user-address-tmpl'
import UserPurchaseSummaryComp from '@/components/common/user-purchase-summary/user-purchase-summary-tmpl'
import { useMixpanel } from '@base-shared/composables/use-mixpanel'
import { useUserStore } from '@base-shared/stores/user';

export default {
  name: 'purchase',
  inject: [
    '$currentUser',
    '$utils'
  ],
  components: {
    UserAddress: UserAddressComp,
    UserPurchaseSummary: UserPurchaseSummaryComp
  },
  watch: {
    '$route.params' (newVal) {
      this.setCenterPanel()
    },
    /**
     * Watches the `userStore.currentUser` for changes. Replacement
     * for the old `USER_DETAILS_AVAILABLE_IN_VUE` from EventBus.
     */
    'userStore.currentUser': {
      handler (newValue) {
        if (!newValue) return
        if (this.userInfo && (this.userInfo.address.firstName === '' && this.userInfo.address.lastName === '')) {
          const userInfo = this.$utils.clone(this.userInfo)
          userInfo.address.firstName = newValue.firstName
          userInfo.address.lastName = newValue.lastName
          this.userInfo = userInfo
        }
      },
      deep: true
    }
  },
  mixins: [AuthMixin],
  data () {
    return {
      profileColumnHeaderIconClass: { icon: true },
      centerPanelOptions: { address: 'address', payment: 'payment', summary: 'summary', finish: 'finish' },
      centerPanel: null,
      userInfo: null,
      planName: null,
      stepItemIsDone: {
        address: false,
        payment: false,
        summary: false
      }
    }
  },
  setup () {
    // Expose the user store to the Options API context.
    return { userStore: useUserStore() };
  },
  methods: {
    setCenterPanel () {
      this.centerPanel = null
      this.planName = this.$route.params.plan

      if (this.$route.params && this.$route.params.centerPanel) {
        // Validate current step
        const validateStepItem = this.handleStepsItemContract(this.$route.params.centerPanel)
        if (!validateStepItem.proceed) {
          this.$router.push(`/purchase/${this.$route.params.plan}/${validateStepItem.prevStep}`, () => {})
          return
        }

        // Added set timout for panel slide animation
        window.setTimeout(() => {
          this.centerPanel = this.$route.params.centerPanel
        }, 1)
      }
    },
    handleStepItemClick (item) {
      const validateStepItem = this.handleStepsItemContract(item)

      if (!validateStepItem.proceed) {
        return false
      }

      this.$router.push(`/purchase/${this.$route.params.plan}/${item}`, () => {})

      // Update user session
      if (item === this.centerPanelOptions.finish) {
        this.$nextTick(_ => {
          this.refreshUserSession()
        })
      }
    },
    handleStepsItemContract (nextStep) {
      const res = { proceed: true, prevStep: this.centerPanelOptions.address }

      switch (nextStep) {
        case this.centerPanelOptions.payment: {
          if (!this.stepItemIsDone.address) {
            res.proceed = false
            res.prevStep = this.centerPanelOptions.address
          }
          break
        }
        case this.centerPanelOptions.summary: {
          if (!this.stepItemIsDone.address) {
            res.proceed = false
            res.prevStep = this.centerPanelOptions.address
          }

          if (!this.stepItemIsDone.payment) {
            res.proceed = false
            res.prevStep = this.centerPanelOptions.address
          }
          break
        }
        case this.centerPanelOptions.finish: {
          const stepsToBeDone = [this.centerPanelOptions.address, this.centerPanelOptions.payment, this.centerPanelOptions.summary]

          for (const indx in stepsToBeDone) {
            const stepItem = stepsToBeDone[indx]

            if (!this.stepItemIsDone[stepItem]) {
              res.proceed = false
              res.prevStep = stepItem
              break
            }
          }

          if (res.prevStep === this.centerPanelOptions.summary) {
            res.prevStep = this.centerPanelOptions.address
          }

          if (this.$currentUser.hasGroupExtended()) {
            res.proceed = true
          }
          useMixpanel().track(`Upgrade to ${this.$utils.getPlanNameFromBundledPlan(this.$utils.options.plans.PREMIUM)}`)
          break
        }
      }

      return res
    },
    handleUserAddressSubCompChange (event) {
      if (event.action === 'USERS_INFO_ADDRESS_UPDATED') {
        // Update Users Info
        const userInfo = this.$utils.clone(this.userInfo)
        userInfo.address = event.payload.data
        this.userInfo = this.$currentUser.filterUserInfoFromBackend(userInfo)

        this.handleUpdateStepItemsStatus()
      }
    },
    handleUserPaymentSubCompChange (event) {
      if (event.action === 'PROCEED_TO_NEXT_STEP') {
        this.handleUpdateStepItemsStatus()
        this.handleStepItemClick(this.centerPanelOptions.summary)
      }
    },
    handleInvoiceSummarySubCompChange (event) {
      if (event.action === 'USER_PLAN_UPDATED') {
        const stepItemIsDone = this.$utils.clone(this.stepItemIsDone)
        stepItemIsDone.summary = true

        this.stepItemIsDone = stepItemIsDone
        this.handleStepItemClick(this.centerPanelOptions.finish)
      }
    },
    handleUpdateStepItemsStatus () {
      const stepItemIsDone = this.$utils.clone(this.stepItemIsDone)

      if (this.userInfo._edit.hasAddressInfo) {
        stepItemIsDone.address = true
      }

      if (this.userInfo._edit.hasCreditCardInfo) {
        stepItemIsDone.payment = true
      }

      this.stepItemIsDone = stepItemIsDone
    },
    handleTutorialClick () {
      const targetLink = CONFIG.HELP_CENTER_URL
      window.open(targetLink)
    },
    handleContinueClick () {
      this.$router.push('/menu')
    }
  },
  mounted () {
    this.isAuthenticated({
      callback: () => {
      // Get Users Info from backend then load center panel
        this.$currentUser.getUserInfoFromBackend({
          callback: (userInfo) => {
            this.userInfo = userInfo
            this.handleUpdateStepItemsStatus()
            this.setCenterPanel()
            this.handleDatatransPaymentResponseData()
            this.$utils.mainLoader(false)
          }
        })
      }
    })
  }
}
